import { SkeletonRect } from "@/lib/skeleton";

export const CardHandRaisingSkeleton = () => {
  return (
    <>
      <SkeletonRect height={200} width={264} />
    </>
  );
};
